import React, { useEffect, useState, useMemo } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";


import DeleteModal from "../../components/Common/DeleteModal";

import TableContainerV1 from "components/Common/TableContainerV1";
import { isEmpty } from "lodash";
import ToastDialog from "common/ToastDialog";
import {faEdit} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { deleteRoleDataAccessById, getRoleDataAccessList } from "helpers/UAM/roleDataAccess.helper";
import Breadcrumbs from "components/Common/Breadcrumb"
const RoleDataAccess = props => {

  //meta title
  document.title = "Role based data access | DMS";
  const navigate = useNavigate();
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [roleDataAccessList, setRoleDataAccessList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [deleteModalInfo, setDeleteModalInfo] = useState({});//for delete modal
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });

  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const handleDeleteRoleDataAccess = (info) => {
    setDeleteModalInfo(info);
  }

  const handleEditRoleDataAccess = (info) => {
    const enCodedId = btoa(info.id);
    navigate(`/${roleName}/role-data-access/edit/${enCodedId}`);
  }

  const deleteRoleDataAccess = async () => {
    const {id} = deleteModalInfo;
    const response = await deleteRoleDataAccessById({id});
    if (response.status) {
      setToastInfo({ message: response.message, showToast: true, role: "success" });
      setDeleteModalInfo({});
      getRoleDataAccess();
    } else {
      setToastInfo({ message: response.message, showToast: true, role: "error" });
    }
  }


  // Customber Column
  const columns = useMemo(
    () => [
      {
        Header: 'Role Name',
        accessor: 'roleName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.row.original.role?.displayName || '-';
        }
      },
      {
        Header: 'Data Access',
        accessor: 'dataAccessName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.row.original.dataAccessName || '-';
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                
                <DropdownItem
                    className="d-flex align-items-center"
                  onClick={() => {
                    const data = cellProps.row.original;
                    handleEditRoleDataAccess(data);
                  }
                  }
                >
                  <faEdit className="fas fa-edit font-size-16 text-success me-1" id="deletetooltip"></faEdit>
                  Edit
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem>
                <DropdownItem
                    className="d-flex align-items-center"
                  onClick={() => {
                    const data = cellProps.row.original;
                    handleDeleteRoleDataAccess(data);
                  }
                  }
                >
                  <i className="fas fa-trash font-size-16 text-danger me-1" id="deletetooltip"></i>
                  Delete
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </DropdownItem>

                
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        }
      },
    ],
    []
  );

  const getRoleDataAccess = async () => {
    const bodyData = {
      page: currentPage,
      searchKey: searchValue,
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
    }
    const response = await getRoleDataAccessList(bodyData);
    if (response.status) {
      setRoleDataAccessList(response.data.data);
      const { totalItems, totalPages, currentPage } = response.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
    }else{
      setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
      setRoleDataAccessList([])
    }
  }

  useEffect(() => {
    getRoleDataAccess();
  }, [searchValue, pageSize, columnId, sortingOrderStatus, currentPage]);


  const handlePageChange = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  }

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
  };


  const handleSearchFilter = (value) => {
    setSearchValue(value);
  };
  const handleClearSearch = () => {
    setSearchValue("");
  };

  const buttonSection = (
    <div className="text-sm-end">
      {
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={() => navigate(`/${roleName}/role-data-access/add`)}
        >
          <i className="mdi mdi-plus me-1" />
          Add New
        </Button>
      }
    </div>
  )

  return (
    <React.Fragment>
      <DeleteModal
        name={"Dealer"}
        show={!isEmpty(deleteModalInfo)}
        onDeleteClick={deleteRoleDataAccess}
        onCloseClick={() => setDeleteModalInfo({})}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dealers" breadcrumbItem="Role Based Data Access" />
          {/* <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="font-weight-semibold">Role Based Data Access</h4> */}
          {/* </div>  */}
            
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainerV1
                    columns={columns}
                    data={roleDataAccessList}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    customSection={buttonSection}
                    sortOptions={sortingOptions}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {toastInfo.showToast && <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>}
    </React.Fragment>
  );
};


export default RoleDataAccess;
